// @flow

import { loadScript } from '../base/util';

import { ADD_DONORBOX_URL } from './actionTypes';

/**
 * Runs a script for running the donorbox dialog when clicked.
 *
 * @returns {getMeethourDonorboxEnabled} - Adds the class into the dom.
 */
export function getDonorboxModal() {


    return loadScript('libs/donorbox-script.min.js').then(() => getMeethourDonorboxEnabled());
}

/**
 * Inflicts the donorbox using this class.
 *
 * @returns {window.DonorBox} - Resolves with the blur effect instance.
 */
export function getMeethourDonorboxEnabled() {
    // eslint-disable-next-line no-return-assign
    return window.DonorBox = { widgetLinkClassName: 'custom-dbox-popup' };
}


/**
 * Adds url to Donation Box.
 *
 * @param {string} url - Url for inflicting the modal .
 * @returns {Function}
 */
export const addDonation = (url: string) => {
    return {
        type: ADD_DONORBOX_URL,
        url
    };
};

